<template>
  <v-container fluid>
    <!-- Temperature Chart -->
    <template v-if="!loading">
      <highcharts
        v-if="!loading"
        ref="highchart"
        :constructor-type="'stockChart'"
        :options="temperatureChartOptions"
      ></highcharts>

      <highcharts
        v-if="!loading"
        ref="highchart2"
        :constructor-type="'stockChart'"
        :options="rainChartOptions"
      ></highcharts>

      <highcharts
        v-if="(!loading) && $env.VUE_APP_WHITE_MARK_ID != 'monithermo'"
        ref="highchart3"
        :constructor-type="'stockChart'"
        :options="windChartOptions"
      ></highcharts>
    </template>
    <template v-else>
      <v-skeleton-loader type="card"></v-skeleton-loader>
    </template>
  </v-container>
</template>

<script>
import moment from "moment";

// Components

// Highcharts
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import stockInit from "highcharts/modules/stock";

// API helper
import api from "../../api";

import cardinals from "../../cardinals";
import { iconUrl } from "../../iconUrl";

import correctedbias from "@/assets/bias";

import {mapState} from 'vuex';

// import axios from 'axios';
// Load the full build.
var _ = require("lodash");

stockInit(Highcharts);

export default {
  name: "Prévisions",
  props: ["geoname", "station_data", "lat-lng"],
  components: {
    highcharts: Chart,
  },

  data: () => ({
    loading: true,
    forecasts: [],
  }),

  computed: {
    ...mapState(["user"]),
    // Temperature Chart Options
    temperatureChartOptions() {
      let series = [];
      let tmaxData = [];
      let tmaxDataS = [];
      let tsData = [];
      let dewPoint = [];
      let dewPointS = [];
      let tempBias = [];
      let forecasts = this.forecasts;

      let formatIcon = this.formatIcon;

      // Set default timezone
      // moment.tz.setDefault;

      let night = [];
      let actualNight = {};

      let minA = [];
      let maxA = [];
      let min = 0;
      //let max = 0;

      this.station_data.forEach((obs) => {
        if (obs.temp != null) {
          tmaxDataS.push([
            moment.utc(obs.date).unix() * 1000,
            +Math.round(obs.temp * 10) / 10,
          ]);
          minA.push(+obs.temp);
          maxA.push(+obs.temp);
        }
        if ((obs.dewpt != null) && (process.env.VUE_APP_WHITE_MARK_ID!='monithermo')) {
          dewPointS.push([
            moment.utc(obs.date).unix() * 1000,
            +Math.round(obs.dewpt * 10) /10,
          ]);
        }
      });
      // Loop trough forecasts array and push [time, value]
      forecasts.forEach((previ, index) => {
        // if (index === 0) this.startHour = previ.date;
        tmaxData.push([
          moment.utc(previ.date).unix() * 1000,
          +previ.tmax,
        ]);
        if (this.user.features.includes("bias_correction")) {
          tempBias.push([
             moment.utc(previ.date).unix() * 1000,
            +Math.round(previ.bias * 100) / 100,
          ]);
        }

        tsData.push({
          x:  moment.utc(previ.date).unix() * 1000,
          y: +previ.tmax + 5,
          marker: {
            symbol: `url(${formatIcon(index)})`,
            height: 20,
            width: 20,
          },
        });
        if (process.env.VUE_APP_WHITE_MARK_ID!='monithermo') {
          dewPoint.push([
             moment.utc(previ.date).unix() * 1000,
            +previ.dpt2m,
          ]);
        }
        minA.push(+previ.tmax);
        minA.push(+previ.dpt2m);

        maxA.push(+previ.tmax);
        maxA.push(+previ.dpt2m);

        min = Math.min(...minA);
        min = Math.floor(min + 5 / 10);

        //max = _.max(maxA) + 5;
        // max = Math.ceil(max / 10) +1 ;
        min = _.min(minA);

        if (previ.is_night && !actualNight.from) {
          actualNight.color = "#E2E2E2";
          actualNight.from = moment.utc(previ.date).unix() * 1000;
        } else if (
          (!previ.is_night && actualNight.from) ||
          (actualNight.from && index + 1 === forecasts.length)
        ) {
          actualNight.to = moment.utc(forecasts[index - 1].date).unix() * 1000;

          night.push(actualNight);
          actualNight = {};
        }
      });

      series.push({
        showInLegend: true,
        color: "#ff0000",
        data: tmaxDataS,
        yAxis: 0,
        name: "Température (Station)",
        states: {
          hover: {
            enabled: true,
          },
        },
        // pointStart: this.startHour,
      });
      if (process.env.VUE_APP_WHITE_MARK_ID!='monithermo') {
        series.push({
          color: "#1dff00",
          data: dewPointS,
          yAxis: 0,
          name: "Point de rosée (Station)",
          states: {
            hover: {
              enabled: true,
            },
          },
          // pointStart: this.startHour,
        });
        }
      // Push data into series array
      series.push({
        showInLegend: false,
        color: "#ff0000",
        data: tmaxData,
        yAxis: 0,
        name: "Température max (Prévisions)",
        dashStyle: "ShortDash",
        states: {
          hover: {
            enabled: true,
          },
        },
        // pointStart: this.startHour,
      });

      if (this.user.features.includes("bias_correction")) {
        series.push({
          showInLegend: false,
          color: "#ff9334",
          data: tempBias,
          yAxis: 0,
          name: "Température corrigée (Prévisions)",
          // dashStyle: "ShortDash",
          states: {
            hover: {
              enabled: true,
            },
          },
          // pointStart: this.startHour,
        });
      }

      series.push({
        color: "#ff0000",
        data: tsData,
        type: "scatter",
        yAxis: 0,
        name: "Temps sensible",
        states: {
          hover: {
            enabled: false,
          },
        },
        // pointStart: this.startHour,
      });
      if (process.env.VUE_APP_WHITE_MARK_ID!='monithermo') {
        series.push({
          color: "#1dff00",
          data: dewPoint,
          yAxis: 0,
          name: this.$t("stations.charts.temperature.serieTitle4"),
          dashStyle: "ShortDash",
          states: {
            hover: {
              enabled: true,
            },
          },
          // pointStart: this.startHour,
        });
      }
      // Return the chart options for axis
      return {
        tooltip: {
          formatter() {
            let tooltipArray = [
              moment(this.x).format("Do MMMM YYYY[,] H[h]mm"),
            ];

            this.points.forEach((point, index) => {
              console.log(index)
              tooltipArray.push(
                point.series.name + ": " + point.y.toFixed(1) + "</b>"
              );
            });

            return tooltipArray;
          },
        },
        xAxis: {
          type: "datetime",
          ordinal: false,
          plotLines: [
            {
              value: new Date(),
              width: 1,
              color: "green",
              dashStyle: "dash",
              label: {
                text: "Actuellement",
                align: "right",
                y: 100,
                x: 0,
              },
            },
          ],
          maxZoom: 3600000,
          labels: {
            formatter: (e) => {
              if (new Date(e.value).getHours() === 0) {
                return moment(e.value).format("D MMM");
              }
              return moment(e.value).format("HH[h]");
            },
            style: {
              fontSize: "10px",
            },
          },
          events: {
            setExtremes: this.syncExtremes,
          },
          plotBands: night,
          tickPositions: this.tickArray,
        },
        yAxis: [
          {
            labels: {
              format: "{value}",
            },
            title: {
              text: this.$t("stations.charts.temperature.yAxis1"),
            },
            opposite: false,
          },
          {
            labels: {
              format: "{value}",
            },
            title: {
              text: this.$t("stations.charts.temperature.yAxis1"),
            },
            opposite: true,
          },
        ],
        // Labels Options
        plotOptions: {
          series: {
            dataGrouping: {
              enabled: true,
            },
            states: {
              inactive: {
                opacity: 1,
              },
            },
            showInNavigator: true,
          },
          line: {
            dataLabels: {
              useHTML: true,
              enabled: false,
              // allowOverlap: true,
              verticalAlign: "top",
              align: "center",
              x: 0, // Offset des points
              y: -22,
              padding: 0,
              style: {
                fontSize: "12px",
              },
            },
            enableMouseTracking: true,
          },
        },
        chart: {
          animation: false,
        },
        time: {
          useUTC: false,
        },
        series,
        rangeSelector: {
          enabled: false,
        },
        navigator: {
          enabled: true,
        },
        scrollbar: {
          enabled: false,
        },
        legend: {
          align: "center",
          enabled: true,
          layout: "horizontal",
          verticalAlign: "top",
        },
      };
    },

    rainChartOptions() {
      let series = [];
      let rain = [];
      let rainS = [];
      let snow = [];
      let rh = [];
      let rhS = [];
     // let etp = [];
      let forecasts = this.forecasts;

      // Set default timezone
      // moment.tz.setDefault;

      let night = [];
      let actualNight = {};

      let max = 100;
      let min = 0;

      this.station_data.forEach((obs) => {
        if (obs.rh != null) {
          rhS.push([
            moment.utc(obs.date).unix() * 1000,
            Math.round(obs.rh),
          ]);
        } else {
          rhS.push([moment.utc(obs.date).unix() * 1000, null]);
        }
        if (obs.rain != null) {
          rainS.push([
            moment.utc(obs.date).unix() * 1000,
            Math.round(obs.rain * 100) / 100,
          ]);
        }
      });

      forecasts.forEach((previ, index) => {
        // Rain or Snow data
        if (previ.csnowsfc > 0) {
          snow.push([
            moment.utc(previ.date).unix() * 1000,
            Math.round(((previ.apcpsfc * previ.csnowsfc * 8) / 10) * 10) / 10,
          ]);

          if (previ.csnowsfc > max)
            max = Math.ceil(((previ.apcpsfc * previ.csnowsfc * 8) / 10) * 10);
        } else {
          rain.push([
            moment.utc(previ.date).unix() * 1000,
            previ.apcpsfc
              ? Math.round(+previ.apcpsfc * 10) / 10
              : +previ.rainmaxhor,
          ]);
          if (previ.apcpsfc > max) max = Math.ceil(previ.apcpsfc);
        }

        // etp.push([previ.timestamp * 1000,
        //   parseFloat(-previ.etp),
        // ]);

        // if (-previ.etp < min) min = min = -previ.etp;

        // Humidity
        rh.push([moment.utc(previ.date).unix() * 1000, Math.floor(previ.rhmin)]);
        // Night data
        if (previ.is_night && !actualNight.from) {
          actualNight.color = "#E2E2E2";
          actualNight.from = moment.utc(previ.date).unix() * 1000;
        } else if (
          (!previ.is_night && actualNight.from) ||
          (actualNight.from && index === forecasts.length - 1)
        ) {
          actualNight.to = moment.utc(forecasts[index - 1].date).unix() * 1000;

          night.push(actualNight);
          actualNight = {};
        }
      });

      series.push({
        showInLegend: true,
        data: rhS,
        color: "#007fff",
        name: "Humidité(Station)",
        yAxis: 1,
        states: {
          hover: {
            enabled: true,
          },
        },
      });

      // Push data into series array
      if (snow.length > 0) {
        series.push({
          type: "column",
          name: "Neige",
          data: snow,
          color: "#1dff00",
          yAxis: 2,
        });
      }
      if (process.env.VUE_APP_WHITE_MARK_ID!='monithermo') {
        series.push({
          type: "column",
          name: "Pluie",
          data: rain,
          color: "#6495ED",
          yAxis: 0,
        });
        series.push({
          type: "column",
          name: "Pluie (station)",
          data: rainS,
          yAxis: 0,
        });
      }
      // series.push({
      //   type: "column",
      //   color: "#75F263",
      //   name: this.$t("stations.charts.rain.serieTitle3"),
      //   data: etp,
      //   yAxis: 0,
      // });
      series.push({
        data: rh,
        color: "#007fff",
        dashStyle: "ShortDash",
        name: "Humidité",
        yAxis: 1,
      });
      // Return the chart options for axis
      return {
        tooltip: {
          formatter() {
            let tooltipArray = [
              moment(this.x).format("Do MMMM YYYY[,] H[h]mm"),
            ];

            this.points.forEach((point, index) => {
              console.log(index)
              tooltipArray.push(
                point.series.name + ": " + point.y.toFixed(1) + "</b>"
              );
            });

            return tooltipArray;
          },
        },
        xAxis: {
          type: "datetime",
          ordinal: false,
          plotLines: [
            {
              value: new Date(),
              width: 1,
              color: "green",
              dashStyle: "dash",
              label: {
                text: "Actuellement",
                align: "right",
                y: 100,
                x: 0,
              },
            },
          ],
          maxZoom: 3600000,
          labels: {
            formatter: (e) => {
              if (new Date(e.value).getHours() === 0) {
                return moment(e.value).format("D MMM");
              }
              return moment(e.value).format("HH[h]");
            },
            style: {
              fontSize: "10px",
            },
          },
          events: {
            setExtremes: this.syncExtremes,
          },
          plotBands: night,
          tickPositions: this.tickArray,
        },
        yAxis: [
          {
            tickAmount: 7,
            min: min,
            max: max,
            labels: {
              format: "{value:.0f}",
            },
            // top: "0%",
            // height: "70%",
            title: {
              text: this.$t("stations.charts.rain.yAxis1"),
            },
            opposite: false,
          },
          {
            tickAmount: 7,
            min: 0,
            max: 100,
            labels: {
              format: "{value:.0f}",
            },
            title: {
              text: this.$t("stations.charts.rain.yAxis2"),
            },
          },
          {
            tickAmount: 7,
            min: min,
            max: 0,
            labels: {
              enabled: false,
              format: "{value:.0f}",
            },
            // top: "70%",
            // height: "10%",
            // title: {
            //   text: "ETP",
            // },
            opposite: false,
          },
        ],
        plotOptions: {
          series: {
            showInNavigator: true,
            dataGrouping: {
              enabled: false,
            },
          },
          column: {
            dataLabels: {
              verticalAlign: "top",
              x: 0,
              y: -22,
              padding: 0,
              align: "center",
              enabled: true,
              style: {
                fontSize: "12px",
              },
              formatter: function () {
                let value = Math.round(this.y * 100) / 100;
                if (value > 0) {
                  return String(value).replaceAll(".", ",");
                } else {
                  return "";
                }
              },
            },
            enableMouseTracking: true,
          },
        },
        // chart: {
        //   height: 180,
        // },

        time: {
          useUTC: false,
        },
        series,
        rangeSelector: {
          enabled: false,
        },
        navigator: {
          enabled: true,
        },
        scrollbar: {
          enabled: false,
        },
        legend: {
          align: "center",
          enabled: true,
          layout: "horizontal",
          verticalAlign: "top",
        },
      };
    },

    windChartOptions() {
      let series = [];
      let windSpeed = [];
      let windSpeedS = [];
      let gust = [];
      let gustS = [];
      let forecasts = this.forecasts;
      let getArrow = this.getArrow;

      // Set default timezone
      // moment.tz.setDefault;

      let night = [];
      let actualNight = {};

      let max = 0;

      this.station_data.forEach((obs) => {
        if (obs.wind != null) {
          windSpeedS.push([
            moment.utc(obs.date).unix() * 1000,
            parseFloat(obs.wind * 3.6),
          ]);
        } else {
          windSpeedS.push([
            moment.utc(obs.date).unix() * 1000,
            null,
          ]);
        }
        if (obs.gust != null) {
          gustS.push([
            moment.utc(obs.date).unix() * 1000,
            parseFloat(obs.gust * 3.6),
          ]);
        } else {
          gustS.push([moment.utc(obs.date).unix() * 1000, null]);
        }
      });

      // Loop trough forecasts array and push [time, value]
      forecasts.forEach((previ, index) => {
        windSpeed.push([
          moment.utc(previ.date).unix() * 1000,
          Math.floor(previ.wind_speed * 3.6),
        ]);

        gust.push([
          moment.utc(previ.date).unix() * 1000,
          Math.ceil(previ.gustsfc * 3.6),
        ]);

        if (previ.gustsfc * 3.6 > max) max = Math.ceil(previ.gustsfc * 3.6);

        if (previ.is_night && !actualNight.from) {
          actualNight.color = "#E2E2E2";
          actualNight.from = moment.utc(previ.date).unix() * 1000;
        } else if (
          (!previ.is_night && actualNight.from) ||
          (actualNight.from && index === forecasts.length - 1)
        ) {
          actualNight.to = moment.utc(forecasts[index - 1].date).unix() * 1000;

          night.push(actualNight);
          actualNight = {};
        }
      });

      max += 10;

      series.push({
        color: "#0037ff",
        data: windSpeedS,
        yAxis: 0,
        name: this.$t("stations.charts.wind.serieTitle1"),
        dataLabels: {
          enabled: false,
        },
      });

      series.push({
        color: "#ff0000",
        data: gustS,
        yAxis: 1,
        name: this.$t("stations.charts.wind.serieTitle3"),
        dataLabels: {
          enabled: false,
        },
      });

      // Push data into series array
      series.push({
        color: "#0037ff",
        dashStyle: "ShortDash",
        data: windSpeed,
        yAxis: 0,
        name: this.$t("stations.charts.wind.serieTitle2"),
        dataLabels: {
          align: "top",
          formatter() {
            if (this.point.index % 3 === 0)
              return `<p><i class="fas fa-long-arrow-alt-up"
                    style="margin-left:5px;transform: rotate(${getArrow(
                      cardinals(Math.round(forecasts[this.point.index].dir))
                    )}deg)"
                  ></i></p>`;
          },
        },
      });

      series.push({
        color: "#ff0000",
        data: gust,
        dashStyle: "ShortDash",
        yAxis: 1,
        name: this.$t("stations.charts.wind.serieTitle4"),
        dataLabels: {
          enabled: false,
        },
      });

      // Return the chart options for axis
      return {
        tooltip: {
          formatter() {
            let tooltipArray = [
              moment(this.x).format("Do MMMM YYYY[,] H[h]mm"),
            ];

            this.points.forEach((point, index) => {
              console.log(index)
              tooltipArray.push(
                point.series.name + ": " + point.y.toFixed(1) + "</b>"
              );
            });

            return tooltipArray;
          },
        },
        xAxis: {
          type: "datetime",
          ordinal: false,
          plotLines: [
            {
              value: new Date(),
              width: 1,
              color: "green",
              dashStyle: "dash",
              label: {
                text: "Actuellement",
                align: "right",
                y: 100,
                x: 0,
              },
            },
          ],
          maxZoom: 3600000,
          labels: {
            formatter: (e) => {
              if (new Date(e.value).getHours() === 0) {
                return moment(e.value).format("D MMM");
              }
              return moment(e.value).format("HH[h]");
            },
            style: {
              fontSize: "10px",
            },
          },
          events: {
            setExtremes: this.syncExtremes,
          },
          plotBands: night,
          tickPositions: this.tickArray,
        },
        yAxis: [
          // {
          //   labels: {
          //     enabled: true,
          //     format: "{value}",
          //   },
          //   opposite: false,
          //   title: {
          //     text: this.$t("stations.charts.wind.yAxis1"),
          //   },
          // },
          // {
          //   labels: {
          //     enabled: true,
          //     format: "{value}",
          //   },
          //   title: {
          //     text: this.$t("stations.charts.wind.yAxis1"),
          //   },
          // },
          // {
          //   labels: {
          //     enabled: false,
          //   },
          //   title: {
          //     text: this.$t("stations.charts.wind.yAxis2"),
          //   },
          // },

          {
            tickAmount: 3,
            tickInterval: 10,
            min: 0,
            max: max,
            labels: {
              format: "{value}",
            },
            opposite: false,
            title: {
              text: this.$t("forecasts.windChart.legend1"),
            },
          },
          {
            tickAmount: 3,
            tickInterval: 10,
            min: 0,
            max: max,
            labels: {
              format: "{value}",
            },
            title: {
              text: this.$t("forecasts.windChart.legend1"),
            },
          },
          {
            tickAmount: 3,
            tickInterval: 10,
            min: 0,
            max: max,
            labels: {
              enabled: false,
            },
            title: {
              text: this.$t("forecasts.windChart.legend2"),
            },
          },
        ],
        // Labels Options
        plotOptions: {
          series: {
            showInNavigator: true,
            dataGrouping: {
              enabled: false,
            },
          },
          line: {
            dataLabels: {
              useHTML: true,
              enabled: true,
              verticalAlign: "top",
              align: "center",
              x: 0, // Offset des points
              y: -22,
              padding: 0,
              style: {
                fontSize: "12px",
              },
            },
            enableMouseTracking: true,
          },
        },

        time: {
          useUTC: false,
        },
        series,
        rangeSelector: {
          enabled: false,
        },
        navigator: {
          enabled: true,
        },
        scrollbar: {
          enabled: false,
        },
        legend: {
          align: "center",
          enabled: true,
          layout: "horizontal",
          verticalAlign: "top",
        },
      };
    },

    tickArray() {
      let forecasts = this.forecasts;

      let res = [];

      forecasts.forEach((chunk, index) => {
        console.log(index)
        if (
          moment.utc(chunk.date).local().hours() === 0 ||
          moment.utc(chunk.date).local().hours() === 12
        )
          res.push(moment.utc(chunk.date).unix() * 1000);
      });

      return res;
    },
  },

  methods: {
    /**
     * Fetch API, get forecasts & select only wanted time
     */
    async getForecasts() {
      this.loading = true;
      try {
        let bias;
        // let resbias = await axios.get(`https://biascast.previmeteo.net/pm_${this.$route.params.id_station}/${this.latLng[0]}/${this.latLng[1]}/gfs`)
        if (this.user.features.includes("bias_correction")) {
          bias = correctedbias;
          console.log("bias", bias);
        }
        let result = await api.forecast.getByLatLng(
          this.latLng[0],
          this.latLng[1],
          false
        );

        // if (result.nearest) {
        //   this.city = result.nearest.city;
        // } else if (result.infos) {
        //   this.city = result.infos.city;
        // }

        // Keep only previs data from object
        let forecasts = result.short;

        forecasts = forecasts.filter((fcast) => {
          return moment.utc(fcast.date).diff(moment(), "hours") >= 0 &&
            moment.utc(fcast.date).diff(moment(), "days") <= 7
            ? true
            : false;
        });

        forecasts.forEach((fcast) => {
          if (this.user.features.includes("bias_correction")) {
            fcast.bias = null;
            bias.forEach((element) => {
              if (element.timestamp == fcast.date) {
                fcast.bias = element.t_corrected;
              }
            });
          }
          this.forecasts.push(fcast);
        });

        // this.forecasts = this.forecasts.filter(
        //   (fcast) =>
        //     moment(fcast.date).diff(
        //       this.forecasts3[this.forecasts3.length - 1].date
        //     ) <= 0
        // );
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    },
    cardinals,

    getArrow(str) {
      switch (str) {
        case "N":
          return 0;
        case "NNE":
          return 22.5;
        case "NE":
          return 45;
        case "ENE":
          return 67.5;
        case "E":
          return 90;
        case "ESE":
          return 112.5;
        case "SE":
          return 135;
        case "SSE":
          return 157.5;
        case "S":
          return 180;
        case "SSO":
          return 202.5;
        case "SO":
          return 225;
        case "OSO":
          return 247.5;
        case "O":
          return 270;
        case "ONO":
          return 292.5;
        case "NO":
          return 315;
        case "NNO":
          return 337.5;

        default:
          return "-";
      }
    },

    syncExtremes: function (e) {
      var thisChart = this.chart;
      if (e.trigger !== "syncExtremes") {
        // Prevent feedback loop
        Highcharts.each(Highcharts.charts, function (chart) {
          if (chart !== thisChart) {
            if (chart.xAxis[0].setExtremes) {
              // It is null while updating
              chart.xAxis[0].setExtremes(e.min, e.max, undefined, false, {
                trigger: "syncExtremes",
              });
            }
          }
        });
      }
    },

    formatIcon(index) {
      if (this.forecasts[index].is_night) {
        return iconUrl(this.forecasts[index].ts, true);
      } else {
        return iconUrl(this.forecasts[index].ts);
      }
    },
  },

  // setup() {
  //   const titleStack = ref(["Admin", "Prévisions"]);

  //   return {
  //     titleStack,
  //   };
  // },

  mounted() {
    this.getForecasts();
  },
};
</script>

<style>
.highcharts-label.highcharts-data-label.highcharts-data-label-color-undefined.highcharts-tracker {
  top: 0 !important;
}
</style>
